var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconHiddenApplications(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "icon-application-a",
    d: "M22.5,4.5 L1.5,4.5 L1.5,3 C1.5,1.35 2.85,0 4.5,0 L19.5,0 C21.15,0 22.5,1.35 22.5,3 L22.5,4.5 Z M21,6 L3,6 C1.35,6 0,7.35 0,9 L0,10.5 L24,10.5 L24,9 C24,7.35 22.65,6 21,6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icon-application-c",
    d: "M24,0 L3,0 C1.2525,0 -0.1245,1.488 0.009,3.2295 L1.047,16.7295 C1.167,18.2925 2.4705,19.5 4.038,19.5 L22.9605,19.5 C24.528,19.5 25.8315,18.2925 25.9515,16.7295 L26.9895,3.2295 C27.1245,1.488 25.7475,0 24,0 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-4 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M7.52922836,6.01556584 C7.614828,6.84104751 6.54236046,9.81962686 6.03677576,11.9611771 C6.12739966,12.8874481 5.65254321,13.5649164 6.03677576,15.4944969 C17.1327861,17.347415 27.8303782,18.931745 30.605258,17.6498067 C30.0779973,15.2077537 30.2945283,11.7870974 29.3278471,8.64424732 C27.9576836,6.84056104 28.5409284,7.16113015 28.4217543,5.90016337 C26.6268136,4.63556286 12.1372701,5.07983634 8.21578507,5.42604802 L7.52922836,6.01556584 Z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    transform: "translate(6 1.5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon-application-b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#icon-application-a"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    x: -6,
    y: -1.5,
    fill: "#D3D3D3",
    fillRule: "nonzero",
    mask: "url(#icon-application-b)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.5 13.5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon-application-d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#icon-application-c"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    x: -4.5,
    y: -13.5,
    fill: "#D3D3D3",
    fillRule: "nonzero",
    mask: "url(#icon-application-d)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHiddenApplications);
export default __webpack_public_path__ + "static/media/icon-hidden-applications.44138b2361b8c0492ec9c56b3f76b7b4.svg";
export { ForwardRef as ReactComponent };